export const productsSliderOptions = (instance, options) => {
    // const hasCartLayout = instance.classList.contains('has-cart-layout')

    let responsiveItemCounts = {
        1024: 3,
        1280: 4,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
            spaceBetween: 0,
            cssMode: false,
            pagination: {
                dynamicBullets: false,
            }
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 0,
        cssMode: true,
        breakpoints: breakpoints
    }
}

export const seenSliderOptions = (instance, options) => {
    let responsiveItemCounts = {
        1024: 3,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
            spaceBetween: 80,
            cssMode: false,
            pagination: {
                dynamicBullets: false,
            }
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 0,
        cssMode: true,
        breakpoints: breakpoints
    }
}

export const articleProductsSliderOptions = (instance, options) => {
    let responsiveItemCounts = {
        1024: 2,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
            spaceBetween: 0,
            cssMode: false,
            pagination: {
                dynamicBullets: false,
            }
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 0,
        cssMode: true,
        breakpoints: breakpoints
    }
}

export const saleEndedProductsSliderOptions = (instance, options) => {
    let responsiveItemCounts = {
        1024: 2,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
            spaceBetween: 0,
            cssMode: false,
            pagination: {
                dynamicBullets: false,
            }
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 0,
        cssMode: true,
        breakpoints: breakpoints,
        navigation: {
            prevEl: document.querySelector('.js-sale-ended-alternatives-prev'),
            nextEl: document.querySelector('.js-sale-ended-alternatives-next'),
            disabledClass: 'is-disabled',
            hiddenClass: 'is-hidden'
        }
    }
}